import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const dls = {
    jpath: ['spectra', 'dls'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default dls;
//# sourceMappingURL=dls.js.map